import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { RootState } from '../app/redux/store'

interface PublicOnlyProps {
  children: React.ReactNode
}

export default function PublicOnly({ children }: PublicOnlyProps) {
  const isAuthenticated = useSelector((state: RootState) => state.auth.authenticate)

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}

